import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import GConf from '../../AssetsM/generalConf';
import { ToWords } from 'to-words';

function FactureCamion() {
    let { fid } = useParams()
    let camData = JSON.parse(localStorage.getItem(`${GConf.SystemTag}_Camion_LocalD`));
    const Cam_ID = camData.Cam_ID;
    let [articleL, setArticleL] = useState([])
    let [factureData, setFactData] = useState([])
    let Offline = JSON.parse(localStorage.getItem(`${GConf.SystemTag}_Camion_Offline`));

    useEffect(() => {
        axios.post(`${GConf.ApiCamionLink}/mf/select`, {
            tag: GConf.SystemTag,
            fid: fid,
            camId: Cam_ID
          })
          .then(function (response) {
                setArticleL(JSON.parse(response.data[0].Articles))
                setFactData(response.data[0])
                console.log(response.data)
          }).catch((error) => {
            if(error.request) {
              const FactureTarged = Offline.facture.find((facture) => facture.F_ID == fid);
              if (FactureTarged) {
                setArticleL(JSON.parse(FactureTarged.Articles))
                setFactData(FactureTarged)
              }
            }
          });
    }, [])

    const toWords = new ToWords({
    localeCode: 'fr-FR',
    converterOptions: {
        //currency: true,
        ignoreDecimal: true,
        ignoreZeroCurrency: false,
        doNotAddOnly: false,
    }
    });

    function findX(z, y) {
        return (z / (1 + y / 100)).toFixed(3);
    }

    const FactureHeader = () =>{
        return(<>
            {/* <div> N &emsp;| Des &emsp;| Qte &emsp;| Pu &emsp;| Pt &emsp;</div>
            <div>________________________</div> */}
            <div className='row mb-2 p-1'>
                <div className='col-6 fw-bold'>Des</div>
                <div className='col-2 fw-bold'>| Qté</div>
                <div className='col-2 fw-bold'>| PU</div>
                <div className='col-2 fw-bold'>| Pt</div>
            </div>
        </>)
    }

    const ArticleListCard = (props) =>{
        return(<>
                {/* <div >:{props.index + 1  }:: | {props.data.Name} </div>
                <div >{props.data.Qte} *  {props.data.Prix}  =  {props.data.PU}</div>
                <b>........................................</b> */}
                <div className='row mb-0'>
                    <div className='col-6'><b>{props.data.Name}</b></div>
                    <div className='col-2'>{props.data.Qte}</div>
                    <div className='col-2'>{factureData.Tota ? props.data.Prix : '00.000'} </div>
                    <div className='col-2'>{props.data.PU}</div>
                </div>
                <small>...............................................................................................................................................</small>
        </>)
    }


    return ( <>
           <div className="container mb-4">
                <h2 className='text-center'>Facture Client</h2> 
                <div className='row' style={{border:'2px solid black', padding : 15, borderRadius : 10}}>
                    <div className='col-12' >
                        <div className='text-danger'><b>Société Fils Sghairi De Commerce Du Nord</b></div>
                        <div className='text-secondary'><b>VILLE: </b> SIDI BOUROUIS</div>
                        <div className='text-secondary'><b>MATRICULE F : </b> 1914177/Q</div>
                        <div className='text-secondary'><b>TEL : </b> 97913068</div>
                        <div className='text-secondary'><b>FAX : </b> 78898081</div>
                        -------------------------------------------------------
                    </div>
                    <div className='col-12'>
                        <div className='text-secondary'><b>CODE FACTURE : </b> {fid}</div>
                        <div className='text-secondary'><b>DATE : </b> {new Date(factureData.Cre_Date).toLocaleDateString('fr-FR').split( '/' ).join( '-' )}</div>
                        <div className='text-secondary'><b>CLIENT: </b> {factureData.Name}</div>
                        <div className='text-secondary'><b>M.F : </b> {factureData.Code_Fiscale}</div>
                        <div className='text-secondary'><b>ADRESSE  : </b> {factureData.Adress}</div>
                    </div>
                </div>
                <br />
                <br />
                <FactureHeader />
                _____________________________________________________________
                <br />
                {articleL.map( (artData,index) =>  <ArticleListCard key={index} data={artData} index={index} /> )}    
            </div>
            <br />
            <br />
             
           <div style={{border:'2px solid black', padding : 15, borderRadius : 10}}>
                <div>Totale H.T: {findX(factureData.Tota,19)}</div>
                <div>TVA: 19 %</div>
                <div>Timbre: 1000 </div>
                <div><b>TTC: {(parseFloat(factureData.Tota) + 1).toFixed(3)}</b></div>
           </div>
           <br />
           
           Facture arrêtée au total {factureData.Tota ? toWords.convert(factureData.Tota + 1): ''} Dinar et {factureData.Tota ? (parseFloat(factureData.Tota + 1) % 1).toFixed(3) : ''} millimes 
    </> );
}

export default FactureCamion;